import { Grid, Container } from "@mui/material";
import ButtonNav from "../components/General/ButtonNav";
import { useAuth } from "../context/AuthContext";

import ManageSearchRoundedIcon from "@mui/icons-material/ManageSearchRounded";
import BadgeRoundedIcon from "@mui/icons-material/BadgeRounded";
// import FolderOpenRoundedIcon from "@mui/icons-material/FolderOpenRounded";

export default function Party() {
  const { hasPermission } = useAuth();

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Grid container spacing={2} sx={{ mt: 2 }}>
        {hasPermission("buscar partes legales") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Buscar Partes Legales"
              subtitle="Buscar nombre o documento de la persona"
              icon={<ManageSearchRoundedIcon />}
              color="#2563eb"
              to="/legalFile/parties/search"
            />
          </Grid>
        )}

        {hasPermission("ver clientes") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Clientes"
              subtitle="Agrupar partes duplicadas bajo un mismo cliente"
              icon={<BadgeRoundedIcon />}
              color="#7c3aed"
              to="/legalFile/parties/clients"
            />
          </Grid>
        )}

        {/* {hasPermission("ver partes legales") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Ver Partes Legales"
              subtitle="Ver partes legales"
              icon={<FolderOpenRoundedIcon />}
              color="#10b981"
              to="/legalFile/parties/manager"
            />
          </Grid>
        )} */}
      </Grid>
    </Container>
  );
}
